import React, { useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { ChevronDown, Weight } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";

function Blog7D() {
  const [loading, setLoading] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
              const [formType, setFormType] = useState(""); // stores which button opened the form
          const [contactForm, setContactForm] = useState({
            fullname: "",
            company: "",
            website: "",
            email: "",
            phone: "",
            message: "",
          });
          const handleContactChange = (e) => {
            const { name, value } = e.target;
            setContactForm((prev) => ({ ...prev, [name]: value }));
          };
          
          
          const isBusinessEmail = (email) => {
            const freeDomains = [
              "gmail.com",
              "yahoo.com",
              "hotmail.com",
              "outlook.com",
              "aol.com",
              "icloud.com",
              "mail.com",
              "live.com"
            ];
            const domain = email.split("@")[1]?.toLowerCase();
            if (!domain) return false;
            return !freeDomains.includes(domain);
          };
          
          
          const handleContactSubmit = async (e) => {
            e.preventDefault();
           
            setLoading(true); // show loading message
            const { fullname, company, website, email, phone, message} = contactForm;
          
          
            // Basic validation
            if (!fullname || !email || !message || !company || !phone ) {
              alert("Please fill all required fields.");
                setLoading(false); // show loading message
          
              return;
            }
          if (!isBusinessEmail(email)) {
              alert("Please enter a business email, not Gmail/Yahoo/etc.");
                setLoading(false); // show loading message
          
              return;
            }
           
          
            try {
                try {
    const emailCheckResponse = await fetch(
      `https://pinakinedgemedia.com/api/validateEmail?email=${email}`
    );
    const emailCheckData = await emailCheckResponse.json();

    if (!emailCheckData.exists) {
      setLoading(false);
      alert("❌ The entered email does not exist. Please use a valid business email.");
      return;
    }
  } catch (err) {
    setLoading(false);
    console.error("Email check failed:", err);
    alert("⚠️ Could not verify email existence. Try again later.");
    return;
  }
              const response = await fetch("https://pinakinedgemedia.com/api/sendContactMail", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
  ...contactForm,
  formType, // ✅ add formType manually here
}),

              });
          
              if (response.ok) {
                 setShowSuccessModal(true);  // ✅ This triggers modal to open
                 setLoading(false); // show loading message
                 setContactForm({
                  fullname: "",
                  company: "",
                  website: "",
                  email: "",
                  phone: "",
                  message: "",
                });
              } else {
                alert("Error sending message.");
              }
            } catch (err) {
              console.error(err);
              alert("Error sending message.");
            }
          };
  return (
    <div>
      <Header />
      <main>
         <AnimatePresence>
                                {showSuccessModal && (
                                  <motion.div
                                    className="modal-overlay show"
                                    initial={{ opacity: 0 }}
                                    animate={{ opacity: 1 }}
                                    exit={{ opacity: 0 }}
                                    style={{
                                      position: "fixed",
                                      top: 0,
                                      left: 0,
                                      width: "100%",
                                      height: "100%",
                                      background: "rgba(0,0,0,0.5)",
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                      zIndex: 9999,
                                    }}
                                  >
                                    <motion.div
                                      className="modal show"
                                      initial={{ scale: 0.8, opacity: 0 }}
                                      animate={{ scale: 1, opacity: 1 }}
                                      exit={{ scale: 0.8, opacity: 0 }}
                                      transition={{ duration: 0.3 }}
                                      style={{
                                        background: "#fff",
                                        padding: "30px",
                                        borderRadius: "10px",
                                        width: "400px",
                                        textAlign: "center",
                                        boxShadow: "0 10px 25px rgba(0,0,0,0.2)",
                                      }}
                                    >
                                      <h2 style={{ fontSize: "20px", marginBottom: "10px" }}>
                                        Message Sent!
                                      </h2>
                                      <p>Thank you for contacting us. We will get back to you shortly.</p>
                                      <button className="vc rg lk gh ml il hi gi _l"
                                        onClick={() => setShowSuccessModal(false)}
                                       
                                      >
                                        Close
                                      </button>
                                    </motion.div>
                                  </motion.div>
                                )}
                              </AnimatePresence>
        {/* 🔹 FAQ Section */}
        <section className="i ji ii db">
        
      <div className="bb ze ki xn 2xl:ud-px-0">
        <div className="tc sf yo zf kq">
          <div className="ro1">
            <div className="animate_top rounded-md shadow-solid-13 bg-white dark:bg-blacksection border border-stroke dark:border-strokedark p-7.5 md:p-10">
              
              
              <div className="container">
               <div className="left">
          <img src="../images/blogim6.png" className="vd" alt="Blog" />
        </div>
          <div className="right">
<h2 className="ek vj 2xl:ud-text-title-lg kk wm nb gb mk">
             How B2B Demand Generation Helps Businesses Build a Stronger Sales Pipeline
              </h2>
                <ul className="tc uf cg 2xl:ud-gap-15 fb">
                <li>
                  <span className="rc kk wm">Published On: </span>May 29, 2026
                </li>
                  <li>
                   <span className="rc kk wm">Published by:</span> Pinakinedge Media
                </li>
              </ul>
          </div>
            </div>
            <br/>
                <p className="jutfy">
                  In today’s competitive B2B market, businesses cannot depend only on cold outreach or random marketing campaigns to generate leads. Buyers are more informed, decision-making cycles are longer, and companies need a more structured approach to attract the right prospects.
                  <br/>
                  This is where B2B demand generation plays an important role.
                  <br/>
                  Demand generation is not just about collecting leads. It is about creating awareness, building trust, identifying the right audience, and helping sales teams connect with prospects who are more likely to convert.
</p>
              <p className="mb bgimh">
           For businesses that want consistent growth, a strong demand generation strategy can become the foundation of a healthy and predictable sales pipeline.
              </p>
             
              <p className="mb bgimh">
       What Is B2B Demand Generation?
              </p>
               <p className="jutfy">
            B2B demand generation is a marketing strategy focused on creating interest in a company’s products or services among the right business audience.It includes multiple activities such as:
              </p>
              
               <ul className="jutfy">
                <li>•	Content marketing</li>
<li>•	Email marketing</li>
<li>•	Content syndication</li>
<li>•	Account-based marketing

</li>
<li>•	Paid campaigns</li>
<li>•	Lead nurturing</li>
<li>•	Intent-based targeting</li>
<li>•	Sales and marketing alignment</li>
               </ul>
            
              <p className="jutfy">
                The goal is simple: reach the right people, educate them, and move them closer to a buying decision.
              </p>

              <p className="mb bgimh">
           Why B2B Companies Need Demand Generation
              </p>
               
               <ul className="jutfy">
                <li>
                 •	Many companies struggle because they generate leads that are either unqualified, not ready to buy, or not relevant to their target market. This wastes time for both marketing and sales teams.   </li>
  <li>•	A proper demand generation strategy helps solve this problem by focusing on the right audience from the beginning.

                </li>
              </ul>
               <p className="jutfy">
When combined, these two data sources give Martech companies a powerful window into who is in-market right now and what solutions they’re considering.
              </p>
              <p className="mb bgimh">
        Why B2B Companies Need Demand Generation
<br/>
<br/>
1. It Helps Attract Qualified Leads

              </p>
               <p className="jutfy">
              Not every lead is valuable. A strong demand generation campaign targets decision-makers, influencers, and companies that match your ideal customer profile.
              <br/>
              This means your sales team spends more time speaking with prospects who actually have a need, budget, or interest.
              <br/>
              <br/>
             
The result: higher-quality leads, improved conversion rates, and lower customer acquisition costs.
              </p>
            
                 <p className="mb bgimh">
      2.It Builds Brand Awareness
              </p>
            
               <ul className="jutfy">
              <li>•	B2B buyers usually do not make decisions overnight. They research, compare, and evaluate multiple options before speaking to a sales team.</li>
              <li>•	Demand generation helps your brand stay visible during this research phase through useful content, targeted campaigns, and consistent communication.</li>
              </ul>
              
            
              <p className="mb bgimh">
     3. It Supports the Sales Team
              </p>
             
            <ul className="jutfy">
              <li>
                •	Sales teams perform better when they have better leads.</li>
 <li>•	With the right demand generation strategy, sales teams receive prospects who are already aware of the brand, understand the solution, and are more open to a conversation.

              </li>
              <li>• This improves sales productivity and increases the chances of conversion.</li>
            </ul>
            
             <p className="mb bgimh">
              4. It Improves Pipeline Predictability
             </p>
             <ul className="jutfy">
              <li>
                •	Random marketing efforts often create random results.</li>
  <li>•	Demand generation brings structure to the process. It helps businesses plan campaigns, track performance, measure lead quality, and improve pipeline visibility.

              </li>
              <li>
                •	This makes growth more predictable and scalable.</li>
             </ul>
             
                  <p className="mb bgimh">
Common Mistakes in B2B Demand Generation
               </p>
               <ul  className="jutfy">
             
  <li>•	Targeting a very broad audience  </li>
  <li>•	Focusing only on lead quantity  </li>
  <li>•	Not aligning marketing with sales  </li>
  <li>•	Using weak or generic content  </li>
  <li>•	Ignoring lead nurturing

                </li>
                 <li>•	Not tracking campaign performance  </li>
                  <li>•Sending leads to sales too early  </li>
               </ul>

                  <p className="mb bgimh">
How Pinakinedge Media Helps Businesses Grow
               </p>
                 <p className="jutfy">
                  Pinakinedge Media helps B2B companies build stronger sales pipelines through demand generation, content syndication, account-based marketing, and performance marketing solutions.
                  <br/>
                  With a focused approach toward qualified and intent-driven leads, businesses can reach the right audience, improve engagement, and support revenue growth.
                  <br/>
                  Whether a company wants to expand into new markets, increase brand visibility, or generate better sales opportunities, a structured demand generation strategy can make a major difference.
                 </p>

              <div className="animate_top w-full nn/5 vo/3 vk sg hh sm yh tq">
                <form onSubmit={(e) => handleContactSubmit(e)}>
  <div className="tc sf yo ap zf xi1">
    <div className="vd to/2">
      <label className="rc" htmlFor="fullname">Full name</label>
      <input
        type="text"
        name="fullname"
        id="fullname"
        value={contactForm.fullname}
        onChange={handleContactChange}
        className="vd ph sg zk xm _g ch pm hm dm dn em pl/50 xi1 mi"
      />
    </div>

    <div className="vd to/2">
      <label className="rc" htmlFor="company">Company</label>
      <input
        type="text"
        name="company"
        id="company"
        value={contactForm.company}
        onChange={handleContactChange}
        className="vd ph sg zk xm _g ch pm hm dm dn em pl/50 xi1 mi"
      />
    </div>
  </div>

  <div className="tc sf yo ap zf xi1">
    <div className="vd to/2">
      <label className="rc" htmlFor="website">Phone number</label>
        <input
  type="text"
  name="phone"
  id="phone"
  value={contactForm.phone}
  onChange={(e) => {
    // Allow only digits
    const value = e.target.value.replace(/\D/g, "");
    setContactForm((prev) => ({ ...prev, phone: value }));
  }}
  maxLength={10} // optional: limit to 10 digits
  className="vd ph sg zk xm _g ch pm hm dm dn em pl/50 xi1 mi"
/>

    </div>

    <div className="vd to/2">
      <label className="rc" htmlFor="email">Email address</label>
      <input
        type="email"
        name="email"
        id="email"
        value={contactForm.email}
        onChange={handleContactChange}
        className="vd ph sg zk xm _g ch pm hm dm dn em pl/50 xi1 mi"
      />
    </div>
  </div>
  <div className="fb">
    <label className="rc" htmlFor="message">Comment</label>
    <textarea
      placeholder="Comment"
      rows="3"
      name="message"
      id="message"
      value={contactForm.message}
      onChange={handleContactChange}
      className="vd ph sg zk xm _g ch pm hm dm dn em pl/50 ci"
    ></textarea>
  </div>

  <div className="tc xf">
      <button
  type="submit"
  className="vc rg lk gh ml il hi gi _l"
  disabled={loading}
  onClick={() => {
    setFormType("Blog: How B2B Demand Generation Helps Businesses Build a Stronger Sales Pipeline");
  }}
>
  {loading ? "Please wait..." : " Post Comment"}
</button>
  </div>
</form>
            </div>
            </div>
          </div>
        </div>
      </div>
    </section>
       
      </main>
      <Footer />
    </div>
  );
}

export default Blog7D;
